<template>
  <span v-if="!hasType">&nbsp;</span>

  <component
    :is="component"
    v-else-if="hasTo || hasLink"
    :class="[
      `wrapper--box-card-${item.type}`,
      isProduct ? `wrapper--box-card-product` : '',
    ]"
    :shadow="shadow"
    :is-product="isProduct"
    :to="hasTo ? to : {}"
    :link="hasLink ? link : ''"
    :target="hasLink ? target : ''"
    :item="item"
    :base="base"
    :lazy="lazy"
  />

  <component
    :is="component"
    v-else-if="hasType"
    :shadow="shadow"
    :is-product="isProduct"
    :item="item"
    :base="base"
    :lazy="lazy"
  />
</template>

<script>
import { ladFnCapitalize } from '@/utils'

export default {
  name: 'LadCard',
  components: {
    LadCardPost: () =>
      import(/* webpackChunkName: "lad-card-post" */ './components/post'),
    LadCardLocation: () =>
      import(
        /* webpackChunkName: "lad-card-location" */ './components/location'
      ),
    LadCardCategory: () =>
      import(
        /* webpackChunkName: "lad-card-category" */ './components/category'
      ),
    LadCardItinerary: () =>
      import(
        /* webpackChunkName: "lad-card-location" */ './components/itinerary'
      ),
    LadCardExperience: () =>
      import(
        /* webpackChunkName: "lad-card-experience" */ './components/experience'
      ),
    LadCardPackage: () =>
      import(/* webpackChunkName: "lad-card-package" */ './components/package'),
    LadCardExperienceCustom: () =>
      import(
        /* webpackChunkName: "lad-card-experience-custom" */ './components/experience-custom'
      ),
    LadCardPackageCustom: () =>
      import(
        /* webpackChunkName: "lad-card-package-custom" */ './components/package-custom'
      ),
  },
  props: {
    shadow: { type: String, default: 'never' },
    item: { type: Object, required: true },
    base: { type: String, required: true },
    to: { type: Object, default: () => ({}) },
    link: { type: String, default: '' },
    target: { type: String, default: '' },
    lazy: { type: Boolean, default: false },
    isCustom: { type: Boolean, default: false },
  },
  data() {
    return {
      types: [
        'post',
        'location',
        'category',
        'experience',
        'package',
        'itinerary',
      ],
    }
  },
  computed: {
    hasType() {
      return (
        Reflect.has(this.item, 'type') && this.types.includes(this.item.type)
      )
    },
    isProduct() {
      return ['experience', 'package'].includes(this.item.type)
    },
    component() {
      if (['experience', 'package'].includes(this.item.type) && this.isCustom) {
        return `LadCard${ladFnCapitalize(this.item.type)}Custom`
      }
      return `LadCard${ladFnCapitalize(this.item.type)}`
    },
    hasTo() {
      return (
        this.hasType &&
        (Reflect.has(this.to, 'name') || Reflect.has(this.to, 'path'))
      )
    },
    hasLink() {
      return this.hasType && !!this.link
    },
  },
}
</script>
